import React from 'react';
import PropTypes from 'prop-types';

import { fetcher } from '@weezevent/weezjs-core';

import { useTranslation } from 'react-i18next';

import OrderModel from '../../order/models/orderModel';
import { usePrinterContext } from '../../../context/printerContext';
import useAppContext from '../../../context/useAppContext';
import { ToastContext } from '@weezevent/nacre';

export default function PrintTicketPostAction({ actionInstance = null, onClose = () => {} }) {
    const { print } = usePrinterContext();
    const [{ organization }] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    React.useEffect(() => {
        // Should not be enabled for orders
        if (actionInstance?.filtered_items[0] instanceof OrderModel) {
            // context error to say that we cannot print orders
            toast(t('ticket.printer.cannot_print_orders'));
        }

        // We send one "get data" for every attendee
        // This is a temporary hack because the weezclient cannot
        // send more than 128kB of data
        const callbacks = actionInstance.filtered_items.map(attendee => {
            return ({ printer_type, support_type, manufacturer }) => {
                let data = {
                    manufacturer,
                    supportType: support_type,
                    printerType: printer_type,
                    // if we have orders we must send orders:[o1.pk, o2.pk]
                    attendees: [attendee.pk]
                };

                return fetcher.post(`/ticket/organizations/${organization.id}/print`, { data }).then(({ response }) => {
                    return response.printData;
                });
            };
        });

        print(callbacks)
            .catch(e => {
                toast(t('ticket.printer.some_attendees_could_not_print'));
            })
            .finally(() => {
                onClose();
            });
    }, [print, actionInstance]);

    return null;
}

PrintTicketPostAction.propTypes = {
    actionInstance: PropTypes.object,
    onClose: PropTypes.func
};
